import {
    CTA,
    Infobox,
    Spinner,
    Text,
    TextTag,
    TokenTextAppearance,
} from '@volkswagen-onehub/components-core'
import React from 'react'
import {useTranslation} from 'react-i18next'
import styled from 'styled-components'
import {DealerSelectionStatus} from '../../../utils/dealers/getDealerSelectionStatus'

// Same spacing as the form fields it stands in for. Padding, not margin: the
// layer containers reset the margin of their last child, as this one is
const FeedbackContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: ${(props) => props.theme.size.static250};
    padding: 0 0 ${(props) => props.theme.size.dynamic0100};
`

const FeedbackText = styled(Text)`
    margin: 0;
`

export interface DealerSelectionFeedbackProps {
    status: DealerSelectionStatus.LOADING | DealerSelectionStatus.UNAVAILABLE
    onRetry: () => void
}

/**
 * Stands in for the province and dealer selects of the quotation form while
 * their lists are loading, or when they could not be loaded, so that the
 * rest of the form keeps its layout.
 */
export function DealerSelectionFeedback({
    status,
    onRetry,
}: DealerSelectionFeedbackProps): React.JSX.Element {
    const {t} = useTranslation('app')

    if (status === DealerSelectionStatus.LOADING) {
        return (
            <FeedbackContainer role="status" aria-live="polite">
                <Spinner />
                <FeedbackText
                    tag={TextTag.p}
                    appearance={TokenTextAppearance.copy200}
                >
                    {t('form.dealerSelection.loading')}
                </FeedbackText>
            </FeedbackContainer>
        )
    }

    return (
        <FeedbackContainer>
            <Infobox role="alert" appearance="error">
                <FeedbackText tag={TextTag.p}>
                    {t('form.dealerSelection.unavailable')}
                </FeedbackText>
            </Infobox>
            <CTA
                tag="button"
                type="button"
                emphasis="secondary"
                size="small"
                onClick={onRetry}
            >
                {t('form.dealerSelection.retry')}
            </CTA>
        </FeedbackContainer>
    )
}
